import type { Profile } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";

const AGE_CONSIDERED_ADULT = 18;
const DOB_FORMAT = "MM/DD/YYYY";

export const isAdult = (dob: Profile["dob"]) => {
  const today = dayjs();
  const timeAgo = today.subtract(AGE_CONSIDERED_ADULT, "year");
  const birthDate = dayjs(dob, DOB_FORMAT);

  return birthDate.isBefore(timeAgo) || birthDate.isSame(timeAgo);
};
